import React, { useEffect, useRef } from "react";

const Layout9 = ({ data }) => {
    const {
        video,
        brand,
        canvas,
        label,
        description,
        leftButtonText,
        rightButtonText,
        belowButtonText,
    } = data;

    const videoRef = useRef(null);

    const buttonColor =
        canvas?.buttonColor ||
        brand?.color ||
        "#e03326";

    const titleColor =
        canvas?.titleColor ||
        "#000000";

    const descColor =
        canvas?.descColor ||
        "#ffffff";

    const buttonTextColor =
        canvas?.buttonTextColor ||
        "#000000";

    /*
     * Keep video playing
     */
    useEffect(() => {
        if (!videoRef.current) return;

        const videoElement = videoRef.current;

        videoElement.play().catch(() => { });
    }, [video?.url]);

    return (
        <div
            className="
                relative
                w-full
                h-full
                overflow-hidden
                bg-cover
                bg-center
                bg-no-repeat
            "
            style={{
                backgroundImage: canvas?.backgroundImageUrl
                    ? `url(${canvas.backgroundImageUrl})`
                    : undefined,
                backgroundColor: "#ffffff",
            }}
        >

            {/* =========================================
                VIDEO SECTION
            ========================================= */}
            <div
                className="
                    absolute
                    left-[2.3%]
                    top-[18%]
                    w-[55%]
                    h-[58%]
                    flex
                    items-center
                    justify-center
                "
            >
                {video?.url && (
                    <video
                        ref={videoRef}
                        src={video.url}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="
                            w-full
                            h-full
                            object-cover
                            border-[3px]
                            border-white
                            shadow-md
                        "
                    />
                )}
            </div>


            {/* =========================================
                RIGHT CONTENT
            ========================================= */}
            <div
                className="
                    absolute
                    right-[3%]
                    top-[13%]
                    w-[38%]
                    h-[75%]
                    flex
                    flex-col
                    items-center
                "
            >

                {/* =====================================
                    BRAND LOGO
                ===================================== */}
                <div
                    className="
                        w-full
                        h-[22%]
                        flex
                        items-center
                        justify-center
                    "
                >
                    {brand?.logoUrl && (
                        <img
                            src={brand.logoUrl}
                            alt="Brand"
                            className="
                                max-w-[42%]
                                max-h-full
                                object-contain
                            "
                        />
                    )}
                </div>


                {/* =====================================
                    LABEL
                ===================================== */}
                <div
                    className="
                        w-full
                        h-[12%]
                        flex
                        items-center
                        justify-center
                    "
                >
                    <h1
                        className="
                            text-3xl
                            font-bold
                            italic
                            tracking-wide
                            text-center
                        "
                        style={{
                            color: titleColor,
                        }}
                    >
                        {label}
                    </h1>
                </div>


                {/* =====================================
                    DIVIDER
                ===================================== */}
                <div
                    className="
                        w-[85%]
                        h-[2px]
                        shrink-0
                    "
                    style={{
                        backgroundColor: buttonColor,
                    }}
                />


                {/* =====================================
                    DESCRIPTION
                ===================================== */}
                <div
                    className="
                        w-[70%]
                        flex-1
                        flex
                        items-start
                        justify-center
                        text-center
                        px-2
                        mt-3
                    "
                >
                    <p
                        className="
                            text-2xl
                            font-bold
                            leading-tight
                        "
                        style={{
                            color: descColor,
                        }}
                    >
                        {description}
                    </p>
                </div>


                {/* =====================================
                    BUTTONS
                ===================================== */}
                <div
                    className="
                        w-full
                        flex
                        items-center
                        justify-center
                        gap-5
                    "
                >

                    {/* LEFT / TRUE BUTTON */}
                    <button
                        type="button"
                        className="
                            relative
                            h-[4.5rem]
                            w-[11rem]
                            flex
                            items-center
                            justify-center
                            text-2xl
                            font-bold
                            uppercase
                            transition-transform
                            duration-200
                            hover:scale-105
                        "
                        style={{
                            backgroundColor: buttonColor,
                            color: buttonTextColor,
                        }}
                    >
                        {/* LEFT ARROW */}
                        <span
                            className="
                                absolute
                                left-4
                                top-[14px]
                                text-4xl
                                font-normal
                                leading-none
                            "
                        >
                            ‹
                        </span>

                        <span>
                            {leftButtonText}
                        </span>
                    </button>


                    {/* RIGHT / FALSE BUTTON */}
                    <button
                        type="button"
                        className="
                            relative
                            h-[4.5rem]
                            w-[11rem]
                            flex
                            items-center
                            justify-center
                            text-2xl
                            font-bold
                            uppercase
                            transition-transform
                            duration-200
                            hover:scale-105
                        "
                        style={{
                            backgroundColor: buttonColor,
                            color: buttonTextColor,
                        }}
                    >
                        <span>
                            {rightButtonText}
                        </span>

                        {/* RIGHT ARROW */}
                        <span
                            className="
                                absolute
                                right-4
                                top-[14px]
                                text-4xl
                                font-normal
                                leading-none
                            "
                        >
                            ›
                        </span>
                    </button>

                </div>


                {/* =====================================
                    BELOW BUTTON TEXT
                ===================================== */}
                <div
                    className="
                        w-full
                        h-[8%]
                        flex
                        items-center
                        justify-center
                        text-center
                    "
                >
                    <p
                        className="
                            text-xl
                            font-bold
                        "
                        style={{
                            color: descColor,
                        }}
                    >
                        {belowButtonText}
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Layout9;